<template>
  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">
        <p>
          Thanks for signing up! You'll be receiving an email with more details momentarily.
        </p>

        <img class="pure-u-1" src="../../assets/images/funkwerks.jpg">
        <p>
          Look forward to 8 limited release beers hand picked by the Funkwerks team every quarter.
          Each Funkwerks Bottle Club box will include insider Funkwerks information, tasting notes,
          and other beer goodies.
        </p>
        <p>
          If you have any questions, concerns, or suggestions feel free to drop us a line anytime at
          <a href="mailto:support@tavour.com">support@tavour.com</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../lib/store';

  export default {
    name: 'SuccessFunkwerks',
    created() {
      /* global ga fbq */
      ga('send', 'pageview', `/${store.get('subscription')}/Success`);
      fbq('track', 'FunkwerksSubsConfirm');

      store.clear();
    },
  };
</script>

<style>
  img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// SuccessFunkwerks.vue?55b27a80